import { defineStore } from 'pinia';
import {
  ref,
  type Ref,
} from 'vue';

export const useSwedishProfileStore = defineStore('SwedishProfile', () => {
  const isBankIdFlow: Ref<boolean> = ref<boolean>(false);

  function setRegisteredThroughBankId() {
    isBankIdFlow.value = true;
  }

  function userRegisteredThroughBankId(): boolean {
    return isBankIdFlow.value;
  }

  return { setRegisteredThroughBankId, userRegisteredThroughBankId };
});
